<template>
    <div v-clickaway="closeSlotsTooltip" v-bind="elementProps" @click="toggleSlotsTooltip($event)">
        <span v-if="isToday">
            {{ date.format('D') }}
            <span v-if="!isMobileLarge">{{ $t('pages.referrals.new.microcopy.today') }}</span>
        </span>

        <span v-else>
            {{ date.format('D') }}
        </span>

        <template v-if="hasAvailableSlots">
            <div class="appointment-calendar-day__slots">
                <span v-if="!isMobileLarge">
                    {{ $tc('pages.referrals.new.microcopy.slots', slotsCount) }}
                </span>

                <div ref="tooltip">
                    <external-calendar-slots
                        ref="externalCalendarSlots"
                        :year="year"
                        :month="month"
                        :day="day"
                        :physician="physician"
                        :isOpen="isSlotsTooltipOpen"
                        :selectedSlotsByDate="selectedSlotsByDate"
                        @emitEvent="emitEvent($event)"
                    ></external-calendar-slots>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import dayjs from 'dayjs'
    import CalendarDayMixin from 'mixins/CalendarDayMixin'
    import ExternalCalendarSlots from 'components/page-elements/referrals-new-schedule/ExternalCalendarSlots'
    import ScreenSizeDetectionMixin from 'mixins/ScreenSizeDetectionMixin'

    export default {
        mixins: [CalendarDayMixin, ScreenSizeDetectionMixin],

        components: {
            ExternalCalendarSlots,
        },

        props: {
            selectedSlotsByDate: { type: Object, required: false, default: undefined },
        },

        computed: {
            isToday() {
                return dayjs().isSame(this.date, 'date')
            },

            hasAvailableSlots() {
                return this.slotsCount > 0 && this.date.isSameOrAfter(dayjs(), 'date')
            },
        },
    }
</script>
